module.exports = __webpack_public_path__ + "img/ch77.44238cb9.jpg";